import * as React from 'react'
import Box from '@mui/material/Box'
import Backdrop from '@mui/material/Backdrop'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import SpeedDialAction from '@mui/material/SpeedDialAction'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import PropTypes from 'prop-types'

const actions = [
  { icon: <FormatListBulletedIcon />, name: 'Preencher formulário' },
  { icon: <AttachFileIcon />, name: 'Enviar arquivo' },
]

const SpeedDialTooltipOpen = ({ onOpenUploadModal, onOpenFormModal }) => {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Box sx={{ position: 'fixed', bottom: 16, right: 16 }}>
      <Backdrop open={open} />
      <SpeedDial
        ariaLabel="SpeedDial tooltip example"
        sx={{ position: 'absolute', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={() => {
              handleClose()
              if (action.name === 'Enviar arquivo'){
                onOpenUploadModal()
              } else if (action.name === 'Preencher formulário'){
                onOpenFormModal()
              }
            }}
          />
        ))}
      </SpeedDial>
    </Box>
  )
}

SpeedDialTooltipOpen.propTypes = {
  onOpenUploadModal: PropTypes.func.isRequired,
  onOpenFormModal: PropTypes.func.isRequired
}

export default SpeedDialTooltipOpen